import { mdiMap } from '@mdi/js'

export default {
  title: 'Province',
  to: 'province-list',
  icon: mdiMap,
  resource: 'ProvinceAdmin',
  action: 'read',
}
